import React from 'react';

import { Icon } from '../../../../utilities/icomoon-css';
import { Button } from '@codeparva/ui-components-library';
import { UnitCardTypes } from '../../UnitCardTypes';
import { useSectionData } from '../../../../sections/rentalPage/components/dynamicForm/hooks/dataContext';
import { unitCardsConfig } from '../config';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';

export const PromoPlanModal = ({
  showModal,
  setShowModal,
}: UnitCardTypes.TPromoPlanModal) => {
  const {
    promoPlans: { data },
    globalContext: { setSelectedPromoPlanId },
  } = useSectionData();

  const NoPromoPlans = () => {
    return (
      <div className="noPromoPlanWrapper">
        <FontAwesomeIcon
          iconClassName="FaInfoCircle"
          style={{
            fontSize: 24,
          }}
        />
        <div className="noPromoPlans">
          {unitCardsConfig.promoPlans.noPromoPlans}
        </div>
      </div>
    );
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const getDescription = (plan: any) => {
    const {
      value: { bills = [] },
    } = plan;
    const promoPlanDescription = bills
      .map((b: { description: string }) => b.description || '')
      .filter((v: { v: any }) => v)
      .join(' || ');
    return promoPlanDescription;
  };

  const handlePromoPlanSelection = (plan: any) => {
    const { id = '' } = plan || {};
    setSelectedPromoPlanId(id);
  };

  return (
    <div className={`modal promoPlanModal ${showModal ? 'is-active' : ''}`}>
      <div className="modal-background" />
      <div className="modal-card modalCard">
        <div className="modal-card-head modalHead is-flex is-justify-content-start">
          <div className="planHeader">{unitCardsConfig.promoPlans.title}</div>
          <div onClick={closeModal} className="closeModal">
            <Icon name="tfw-close-circle-cp" size={16} color="#4F4F4F" />
          </div>
        </div>
        <div className="modal-card-body modalBody">
          {data?.length ? (
            <div>
              {data.map((plan: any, index: number) => {
                return (
                  <div key={index} className="singlePlanWrapper">
                    <div className="planOfferWrapper">
                      <div className="planOffer">{plan.value.title}</div>
                      <div className="planDescription">
                        {getDescription(plan)}
                      </div>
                    </div>
                    <div className="promoCodeButton">
                      <Button onClick={() => handlePromoPlanSelection(plan)}>
                        {unitCardsConfig.promoPlans.applyPromoCode}
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <NoPromoPlans />
          )}
        </div>
      </div>
    </div>
  );
};
